<template>
  <div class="base-table" v-loading="loading">
    <!-- 表格标题功能 -->
    <div v-if="$slots.title" class="table-title">
      <slot name="title" />
    </div>
    <div class="table-header">
      <!-- 表格顶部操作按钮 -->
      <div v-if="config.buttons && config.buttons.length" class="table-btns">
        <template 
          v-for="(btn, name) in hasBtn(config.buttons)"
        >
          <span
            v-if="btn.type === 'tip'"
            :key="`tip-${name}`"
          >{{ btn.name }}</span>
          <el-button
            v-else
            :key="`defalut-${name}`"
            :type="btn.type"
            :style="`color:${btn.color}`"
            :disabled="btn.disabled ? checkList.length == 0 : false"
            :icon="btn.icon"
            :class="btn.class"
            @click="handleBtn('tableAction', { btn, checkList })"
          ><i v-if="btn.iconName" :class="`icon-${btn.iconName}`" />{{ btn.name }}</el-button>
        </template>
      </div>
      <div v-else-if="$slots.buttons" class="table-btns">
        <slot name="buttons" />
      </div>

      <!-- 表格顶部搜索功能 -->
      <div v-if="$slots.search" class="table-search">
        <slot name="search" />
      </div>
    </div>

    <!-- 列表 -->
    <el-table
      ref="tableTem"
      class="table-list"
      :data="data"
      :border="typeof config.border !== 'undefined' ? config.border : defaultProps.border"
      :style="config.style || defaultProps.style"
      :row-key="config.rowKey || defaultProps.rowKey"
      :cell-class-name="config.cellClassName || defaultProps.cellClassName"

      :span-method="config.arraySpanMethod || defaultProps.arraySpanMethod"
      :lazy="config.lazy"
      :load="config.load"
      :tree-props="config.treeProps || defaultProps.treeProps"
      :default-expand-all="config.defaultExpandAll || defaultProps.defaultExpandAll"
      :show-summary="config.showSummary || defaultProps.showSummary"

      @selection-change="handleBtn('handleSelectionChange', $event)"
      @select-all="handleSelectAll"
      @select="handleSelect"
    >
      <template v-if="config.placeholder" #empty>
        <div class="table__placeholder">{{ config.placeholder }}</div>
      </template>

      <template v-for="(item, index) in config.columns">

        <!-- checkbox -->
        <el-table-column
          v-if="item.type === 'selection'"
          :key="`selection-${index}`"
          type="selection"
          :width="item.width"
          :reserve-selection="true"
          :selectable="selectable(item)"
          :fixed="item.fixed ? item.fixed : false"
        />

        <!-- 非 checkbox -->
        <el-table-column
          v-else
          :key="index"
          :label="item.title"
          :type="item.type"
          :column-key="item.key"
          :width="item.width"
          :show-overflow-tooltip="item.showTool"
          :fixed="item.fixed ? item.fixed : false"
        >
          <template #header="scope" v-if="(item.type === 'slot' || item.slot) && item.slotHeaderName">
            <!-- 插槽 -->
            <slot
              :name="item.slotHeaderName"
              :row="scope.row"
              :item="item"
            />
          </template>
          <template #default="scope">
            <!-- 插槽 -->
            <slot
              v-if="item.type === 'slot' || item.slot"
              :name="item.slotName || item.slot || item.key"
              :row="scope.row"
            />

            <!-- 序号 -->
            <span v-else-if="item.type === 'index'">
              {{
                page.currentPage && !config.hidePagination
                  ? (page.currentPage - 1) * page.pageSize +
                    scope.$index +
                    1
                  : scope.$index + 1
              }}
            </span>

            <!-- 树形序号 -->
            <span v-else-if="item.type === 'treeIndex'">
              {{ computedTreeIndex(scope) }}
            </span>

            <!-- 拥有链接 -->
            <span v-else-if="item.urlKey">
              <el-link
                type="primary"
                :href="scope.row[item.urlKey]"
                target="_blank"
              >{{ tableProperties(scope.row, item) }}</el-link>
            </span>

            <!-- 普通内容 -->
            <span
              v-else-if="item.key"
              :style="`color:${colorJudge(item, scope.row)}`"
            >
              {{ tableProperties(scope.row, item) }}
            </span>

            <!-- 按钮 -->
            <span v-else-if="item.btns">
              <template v-for="(btn, name) in hasBtn(item.btns)">
                <template
                  v-if="btnShow(btn, scope.row)"
                >
                  <span
                    v-if="btn.type === 'switch'"
                    class="btn-switch"
                    :key="`btn-switch-${name}`"
                  >
                    <span v-if="btn.name">{{ btn.name }}</span>
                    <el-switch
                      v-model="scope.row[btn.key]"
                      :active-value="btn.activeValue || 1"
                      :inactive-value="btn.inactiveValue || 0"
                      @click="
                        handleBtn('tableAction', {
                          btn,
                          row: scope.row,
                          index: scope.$index,
                        })
                      "
                    />
                  </span>
                  <el-button
                    v-else
                    :key="`btn-default-${name}`"
                    :type="btn.type"
                    :style="`color:${btn.color}`"
                    :disabled="btn.disabledfn && btn.disabledfn(scope.row)"
                    :class="[
                      btn.theme ? `btn-item-${btn.theme}` : '',
                    ]"
                    @click="
                      handleBtn('tableAction', {
                        btn,
                        row: scope.row,
                        index: scope.$index
                      })
                    "
                  >{{ btn.name }}</el-button>
                </template>
                <span v-else-if="btn.hiddenReplace" :key="name">{{ btn.hiddenReplace }}</span>
              </template>
            </span>
          </template>
        </el-table-column>
      </template>
    </el-table>

    <!-- 表格分页 -->
    <BasePagination
      v-if="!config.hidePagination"
      :total="page.total"
      :current-page="page.currentPage"
      :page-size="page.pageSize"
      :page-sizes="page.pageSizes"
      @changePage="handleBtn('changePage', $event)"
      @changeSize="handleBtn('changeSize', $event)"
    />
  </div>
</template>

<script>
import BasePagination from './BasePagination.vue'
import { parseTime } from './parseTime'
import defaultProps from './defaultProps'

export default {
  name: 'BaseTable',
  components: { BasePagination },
  emits: ['action', 'selection-change', 'select-all', 'select', 'changePage', 'changeSize'],

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: () => ({
        columns: defaultProps.columns,
        lazy: defaultProps.lazy,
        load: defaultProps.load,
      })
    },
    page: {
      type: Object,
      default: () => defaultProps.page
    },
    data: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      checkList: [],
      defaultProps: defaultProps
    }
  },

  computed: {
    // 返回有权限的按钮
    hasBtn() {
      return btns => btns
    },
    // 显示值
    tableProperties() {
      return (row, item) => {
        let str = row[item.key]
        if (str === null || str === '') return ''
        // 标识对应显示值
        if (
          item.codeMateVal &&
          Object.prototype.toString.call(item.codeMateVal) === '[object Object]'
        ) {
          if (
            item.codeMateVal[str] &&
            Object.prototype.toString.call(item.codeMateVal[str]) !==
              '[object Object]'
          ) {
            // 旧版本的{值:显示值}
            str = item.codeMateVal[str]
          } else {
            // 新版本的可根据特定key判断
            for (const key in item.codeMateVal) {
              if (
                row[key] !== undefined &&
                row[key] !== null &&
                item.codeMateVal[key][row[key]]
              ) {
                str = item.codeMateVal[key][row[key]]
              }
            }
          }
        }
        // 时间格式
        if (item.format) {
          str = parseTime(str, item.format)
        }
        // 单位
        if (item.unit) {
          str = str + item.unit
        }
        return str
      }
    },
    // 时间格式
    parseTime() {
      return (val, format) => parseTime(val, format)
    },
    // 返回颜色
    colorJudge() {
      return (row, val) => {
        if (
          row.colorJudge &&
          Object.prototype.toString.call(row.colorJudge) === '[object Object]'
        ) {
          if (
            row.colorJudge[val[row.key]] &&
            Object.prototype.toString.call(row.colorJudge[val[row.key]]) !==
              '[object Object]'
          ) {
            // 旧版本的{值:颜色}
            return row.colorJudge[val[row.key]]
          } else {
            // 新版本的可根据特定key判断
            for (const key in row.colorJudge) {
              if (
                val[key] !== undefined &&
                val[key] !== null &&
                row.colorJudge[key][val[key]]
              ) {
                return row.colorJudge[key][val[key]]
              }
            }
          }
        }
      }
    },
    // 按钮显示隐藏
    btnShow() {
      return (btn, row) => {
        if (btn.hidden && btn.show) {
          console.warn(
            'tableTem-head-btns 中hidden与show同时存在,请检查是否为误操作!!'
          )
        }

        // show
        if (typeof btn.show === 'function') {
          return btn.show(row)
        } else if (typeof btn.hidden === 'function') {
          return !btn.hidden(row)
        }

        // #region --- 隐藏
        if (
          btn.hidden &&
          Object.prototype.toString.call(btn.hidden) === '[object Array]'
        ) {
          const flagArr = btn.hidden.slice(1, btn.hidden.length)
          return !flagArr.some(item => {
            return row[btn.hidden[0]] === item
          })
        } else if (
          btn.hidden &&
          Object.prototype.toString.call(btn.hidden) === '[object Object]'
        ) {
          let falg = true
          for (const key in btn.hidden) {
            if (falg) {
              falg = !btn.hidden[key].some(item => {
                return row[key] === item
              })
            }
          }
          return falg
        }
        // #endregion

        // #region --- 显示
        if (
          btn.show &&
          Object.prototype.toString.call(btn.show) === '[object Array]'
        ) {
          const flagArr = btn.show.slice(1, btn.show.length)
          return flagArr.some(item => {
            return row[btn.show[0]] === item
          })
        } else if (
          btn.show &&
          Object.prototype.toString.call(btn.show) === '[object Object]'
        ) {
          let falg = false
          for (const key in btn.show) {
            if (!falg) {
              falg = btn.show[key].some(item => {
                return row[key] === item
              })
            }
          }
          return falg
        }
        // #endregion

        return true
      }
    },
    // 获取select隐藏条件
    getSelectHidden() {
      // #region --- 旧版本循环得到selectHidden
      // let selectHidden = [];
      // this.config.columns.some(item => {
      //   // 循环得到隐藏的条件
      //   if (item.type === "selection" && item.selectHidden?.length > 0) {
      //     selectHidden = item.selectHidden;
      //     return true;
      //   }
      // });
      // #endregion
      let selectHidden = []
      const c_selectHidden = this.config.columns_obj?.selection_u?.selectHidden
      if (c_selectHidden && Object.prototype.toString.call(c_selectHidden) === '[object Array]') {
        selectHidden = c_selectHidden
      }
      return selectHidden
    },
  },

  created() {
    this.formattingConfig()
  },

  beforeMount() {},

  mounted() {
    if (this.config.selectName) {
      // 表头全选显示值
      this.$nextTick(() => {
        document.getElementsByClassName(
          'el-checkbox'
        )[0].parentNode.innerHTML = this.config.selectName
      })
    }
  },

  methods: {
    // config处理
    formattingConfig() {
      this.config.columns_obj = {}
      this.config.columns.forEach((item, index) => {
        if (item.key) {
          this.config.columns_obj.IDX = index
          this.config.columns_obj[item.key] = item
        } else if (item.type) {
          this.config.columns_obj[`${item.type}_u`] = item
        }
      })
    },
    // #region --- 表单控制
    // 表格选择框是否可选 true-可选 false-禁选
    selectable(config) {
      return (row, index) => {
        if (config.selectable?.length > 0) {
          return !config.selectable.some(item =>
            item.slice(1).some(it => row[item[0]] == it)
          )
        }
        return true
      }
    },
    // 表单选择框的隐藏
    checkbox(row) {
      const selectHidden = this.getSelectHidden
      if (selectHidden.length > 0) {
        // 根据条件添加隐藏的样式
        const flag = selectHidden.some(item =>
          item.slice(1).some(it => row.row[item[0]] === it)
        )
        if (flag) {
          return 'mycell'
        }
      }
    },
    // #endregion
    // #region --- 按钮
    // 按钮入口
    handleBtn(name, data) {
      const fn = this[name](name)
      fn && fn(data)
    },
    // 列表按钮
    tableAction(name) {
      return data => {
        const { btn, index } = data
        if (btn.type === 'switch' && index === -1) return
        this.$emit('action', data)
      }
    },
    // 复选
    handleSelectionChange(name) {
      return data => {
        this.checkList = data
        const selectHidden = this.getSelectHidden
        if (selectHidden.length > 0) {
          this.checkList = this.checkList.filter(item => {
            const flag = selectHidden.some(it =>
              it.slice(1).some(t => item[it[0]] === t)
            )
            return !flag
          })
        }
        if (!this.checkList.length) {
          this.$refs.tableTem.clearSelection()
        }
        this.$emit('selection-change', data)
      }
    },
    handleSelectable(row, index) {
      console.log(row,index);
      return false;
    },
    // 全选
    handleSelectAll(selection) {
      this.$emit('select-all', selection)
    },
    // 单选
    handleSelect(selection, row) {
      this.$emit('select', selection, row)
    },
    // #endregion

    clearSelection() {
      this.$refs.tableTem.clearSelection()
    },

    // #region 分页按钮
    changePage(name) {
      return data => {
        this.$emit('changePage', data)
      }
    },
    changeSize(name) {
      return data => {
        this.$emit('changeSize', data)
      }
    },
    // #endregion

    // 计算树形序号
    computedTreeIndex({ row, $index }) {
      if (row.level == 1) {
        return row.parentIndex;
      }
      if (row.level == 2) {
        return `${row.parentIndex}.${row.childrenIndex}`;
      }
    }
  }
}
</script>

<style lang="scss">
.base-table {
  .el-table {
    color: #666666;
  }
  .el-table .mycell .el-checkbox {
    display: none;
  }

  .el-table th.el-table__cell {
    background-color: #FAFAFA;
    font-family: 思源黑体 CN Medium;
    font-weight: 350;
    font-size: 14px;
    color: #333333;
    line-height: 14px;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
  }

  .table-search,
  .table-title,
  .table-btns {
    margin-bottom: 16px;
  }
  .table-search{
    display: flex;
  }
  .table-title {
    font-size: 16px;
    font-weight: 700;
  }

  .table-btns{
    > .el-button {
      margin: 0 10px 0 0;

      > span > i {
        margin-right: 8px;
      }
    }
  }

  .btn-switch {
    display: flex;
    align-items: center;

    > span {
      margin-right: 8px;
    }
  }
  .btn-item-info.el-button--text {
    color: #F2995F;
  }
  .el-button--text {
    font-size: 14px;
    color: #316F7E;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #316F7E;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #316F7E;
  }
}
</style>
